import { render, staticRenderFns } from "./SurfNavMenu.vue?vue&type=template&id=3cd11e80&scoped=true"
import script from "./SurfNavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfNavMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfNavMenu.vue?vue&type=style&index=0&id=3cd11e80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd11e80",
  null
  
)

export default component.exports